import { FC } from "react";

import { RestoreCaseSessionModalProps } from "./types";

const RestoreCaseSessionModal: FC<RestoreCaseSessionModalProps> = ({ isModalVisible, restoringCaseData, removeCurrentData }): JSX.Element => {
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">Warning</h1>
          </div>

          <div className="modal-body">
            <p className="m-0">
              It seems that you were already enrolling a patient but did not finish it.
              Would you like to continue with the existing enrollment?
            </p>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-danger" onClick={removeCurrentData}>No, I would like to start a new enrollment</button>
            <button type="button" className="btn btn-gray" onClick={restoringCaseData}>Yes, take me back to where I was</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestoreCaseSessionModal;
